// extracted by mini-css-extract-plugin
export var leftAlign = "_2z-2";
export var popper = "_2z-0";
export var subtitle = "_2z-1";